export enum DataType {
  Header = `header`,
  Block = `contentBlock`,
}
